import '../../styles/accordion/accordion-button.css'

const AccordionButton = ({title,active,changeActive}) => {
  return (
    <span className='accordion-customButton' onClick={changeActive}>{title} <span className={active ? 'accordion-customButton-icon--active' : 'accordion-customButton-icon'}>&#xf103;</span></span>
  )
}

export default AccordionButton